import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import './checkride.css';
import {
    Grid,
    Button
} from "@material-ui/core";
import Services from '../../../Services';
import { AuditTableApi } from "../../../Services/employee";
import moment from "moment";
import { message } from "antd";
import { useHistory, useLocation } from "react-router-dom";


const PageHeader = lazy(() => import("../../../Components/PageHeader"));
const DynamicFormFields = lazy(() => import("../../../Components/InputComponents/DynamicFormFields"));
const GoBack = lazy(() => import("../../../Components/GoBackButton/GoBack"));
const GoClose = lazy(() => import("../../../Components/GoBackButton/Close"));
const PageLayout = lazy(() => import("../../../Components/LayoutComponents/PageLayout"));
const AuditTable = lazy(() => import("./EnterAuditTable"));

const {
    employee,
    Storage
} = Services;

const EnterAudit = () => {
    const history = useHistory()
    const location = useLocation()
    const storage = new Storage();
    const [tableData, setTableData] = useState([]);
    let templateData = location?.state?.crideDates?.TemplateUsed

    const [crideTextFields, setCrideTextFields] = useState(location?.state?.crideTextFields || {
        assisting: [],
        locomotiveConsist: '',
        TCLoads: '',
        TCEmpties: '',
        TCTotalTonage: '',
        TMTraveled: '',
        Comments: '',
        type: ''
    })
    const [crideAutoComplete, setAutoComplete] = useState(location?.state?.crideAutoComplete || {
        EngineerId: '',
    })
    const [crideDates, setCrideDates] = useState(location?.state?.crideDates || {
        date: '',
        time: '',
        endDate: '',
        endTime: '',

    })
    const [lists, setLists] = useState({
        currentUser: '',
        users: [],
        positions: [],
        departments: [],
        sites: [],
        crews: [],
        assistants: []

    })

    const fetchTableData = async (templateId) => {
        try {
            let response = await AuditTableApi(templateId?.value);
            if (response?.httpStatus == 200) {
                setTableData(response?.data?.map((item, index) => {
                    return {
                        ...item, ...item?.TestingAudit_ItemLists?.map((item, index) => {
                            return {
                                [index]: {}
                            }
                        })
                    }
                }));
            } else {
                console.error("Failed to fetch table data:", response?.message);
            }
        } catch (error) {
            console.error("Error fetching table data:", error);
        }
    };

    const submitBtn = async (event) => {
        message?.destroy()
        event.preventDefault();
        if (!crideDates?.ForemanSupId) return message.error('Kindly Select Foreman or Employee!');
        if (!crideDates?.TemplateUsed) return message.error('Kindly Select Audit Template!');
        if (!crideDates?.Location_Id) return message.error('Kindly Select Location!');
        if (!crideDates?.SubDepartmentID) return message.error('Kindly Select Sub Department!');
        history.push({
            pathname: '/enter-audit-terminal',
            state: {
                crideTextFields,
                crideAutoComplete,
                crideDates,
                tableData
            }
        })
    };

    const setListData = async () => {
        let userList = await employee.checkride_table();
        if (userList?.httpStatus == 200) {
            userList = userList?.data;
            userList.map(row => {
                row.name = `${row.firstName} ${row.lastName}`
            })
        }

        let assistingCrewList = await employee.get_crew_user_listing();

        if (assistingCrewList?.httpStatus == 200) {
            assistingCrewList = assistingCrewList?.data?.rows;
            assistingCrewList.map(row => {
                row.name = `${row?.firstName} ${row?.lastName}`
            })
        }

        let templateList = await employee.get_Template()
        if (templateList?.httpStatus == 200) {
            templateList = templateList?.data
        }
        let siteList = await employee.get_site_listing()
        if (siteList?.httpStatus == 200) {
            siteList = siteList?.data
        }
        let departmentList = await employee.get_subDepartment_listing();
        if (departmentList.httpStatus == 200) {
            departmentList = departmentList?.data || []
        }
        let currentUser = JSON.parse(storage.get('user_profile'))

        setLists((prev) => {
            return {
                ...prev, users: userList, currentUser: currentUser, location: siteList, templateList: templateList, departments: departmentList
            }
        })
        return true
    }

    const getForemanData = async () => {
        const result = await employee.getForemanData()
        let mappedData = result?.data?.rows?.map((item, index) => {
            return {
                id: item?.id,
                name: item?.firstName + " " + item?.lastName
            }
        })
        setLists((prev) => { return { ...prev, assistants: mappedData } })
    }

    const stateMap = {
        1: crideTextFields,
        2: crideDates,
        3: crideAutoComplete,
        5: crideDates,
        12: crideTextFields,
    }


    const handleOnChange = (value, key, type) => {
        if (key == 'TemplateUsed') {
            fetchTableData(value);
        }
        const set = {
            1: setCrideTextFields({ ...crideTextFields, [key]: value }),
            2: setCrideDates({ ...crideDates, [key]: value }),
            3: setAutoComplete({ ...crideAutoComplete, [key]: value.id }),
            5: setCrideDates({ ...crideDates, [key]: value }),
            12: setCrideTextFields({ ...crideTextFields, [key]: value }),
        }
        return set[type];
    }

    const currentUser = JSON.parse(storage.get('user_profile'))

    let fields = [
        { type: 1, name: "Evaluator", initial: `${currentUser?.firstName} ${currentUser?.lastName}`, isDisabled: true, keyName: '', className: 'mbolder' },
        {
            type: 3,
            key: 'name',
            showForm: 'antD',
            options: lists?.assistants?.map(templateList => ({
                value: templateList?.id,
                label: templateList?.name,
            })),
            name: "Foreman or Employee (individual audit)",
            isRequired: true,
            keyName: 'ForemanSupId',
            initial: location?.state?.crideDates?.ForemanSupId?.value
        },

        {
            type: 3,
            key: 'label',
            showForm: 'antD',
            options: lists?.templateList?.map(templateList => ({
                value: templateList?.id,
                label: templateList?.name,
            })),
            name: "Audit Template",
            isRequired: true,
            keyName: 'TemplateUsed',
            initial: location?.state?.crideDates?.TemplateUsed?.value

        },
        {
            type: 3,
            key: 'label',
            showForm: 'antD',
            options: lists?.location?.map(location => ({
                value: location?.id,
                label: location?.title,
            })),
            name: "Location",
            isRequired: true,
            keyName: 'Location_Id',
            initial: location?.state?.crideDates?.Location_Id?.value
        },
        {
            type: 1,
            fieldType: 'text',

            name: "Customer",
            isRequired: true,
            keyName: 'Customer',
            maxLength: '100',
            initial: crideDates?.Customer || ""
        },
        // { type: 7 },
        {
            type: 3,
            key: 'label',
            showForm: 'antD',
            options: lists?.departments?.map(departments => ({
                value: departments?.id,
                label: departments?.title,
            })),
            name: "Sub Department",
            isRequired: true,
            keyName: 'SubDepartmentID',
            initial: location?.state?.crideDates?.SubDepartmentID
        },
        {
            type: 11,
            name: "Date",
            keyName: 'date',
            isRequired: true,
            initial: crideDates?.date,
        },
        {
            type: 5,
            name: "Time",
            keyName: 'AuditTime',
            isRequired: true,
            initial: location?.state?.crideDates?.AuditTime || "",
        },
        {
            type: 6,
            name: "Describe work activities taking place",
            isRequired: true,
            keyName: 'WorkDescription',
            scroll: 'false',
            maxLength: '250',
            initial: location?.state?.crideDates?.WorkDescription || "",

        },
        {
            type: 6,
            name: "Comment",
            isRequired: true,
            keyName: 'EventComments',
            maxLength: '250',
            initial: location?.state?.crideDates?.EventComments || "",
        },
    ];

    useEffect(() => {
        setListData();
        getForemanData()
    }, []);
    useEffect(() => {
        if (templateData) fetchTableData(templateData)
    }, [templateData])
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <PageLayout>
                <Grid className="PagesFrame">
                    <PageHeader />
                    <Grid id="PageTitle">Enter Safety Audit</Grid>
                    <GoBack path={"/safety-testing"} state={{ activeKey: 4 }} />
                    <form onSubmit={submitBtn} >
                        <div className="enter-audit-form" style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "20px" }}>
                            <DynamicFormFields state={stateMap} fields={fields?.slice(0, 14)} onChange={handleOnChange} grid={4} />
                        </div>
                        <Grid xs={12} container justify="flex-end" className="mt50">
                            <GoClose path={"/safety-testing"} state={{ activeTab: 1 }} />
                            <Button
                                type="submit"
                                className="LinkButton"
                            >
                                Next
                            </Button>
                        </Grid>
                    </form>
                </Grid>
            </PageLayout>
        </Suspense>

    );
}

export default EnterAudit;
